import * as d3Module from "d3";

window.d3 = d3Module;

import("c3")
  .then(c3Module => {
    window.c3 = c3Module.default || c3Module;
    return import("./easy_chart/jquery.easy_chart_loader");
  })
  .then(() => {
    window.EASY?.schedule?.define(
      "easy_chart",
      () => /** @type {any} */ (window).jQuery?.easy?.easy_chart,
      "jquery",
      "c3"
    );
  });
